import { render, staticRenderFns } from "./popular.vue?vue&type=template&id=eaf9c76a&"
import script from "./popular.vue?vue&type=script&lang=js&"
export * from "./popular.vue?vue&type=script&lang=js&"
import style0 from "./popular.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports